import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function MaxWavesGuide() {
  return <LocalizedWeatherGuidePage guideKey="maxWaves" />;
}